const propertyCreate = {
  propertyCreate: {
    meta: {
      badge: 'List property',
      title: 'Create a new listing',
      subtitle: 'Share comprehensive details so our team can showcase your property to qualified buyers.',
      success: {
        message: 'Your property has been published successfully.',
        viewButton: 'View listing',
      },
    },
    form: {
      sections: {
        basics: 'Listing overview',
        description: 'Property description',
        location: 'Location details',
        media: 'Media & gallery',
        features: 'Utilities & amenities',
        agent: 'Agent contact',
      },
      fields: {
        title: {
          label: 'Listing title',
          placeholder: 'e.g. Skyline villa overlooking Jeddah Park',
        },
        price: {
          label: 'Price (\uFDFC)',
          placeholder: '2,450,000',
          helper: 'Approx. \uFDFC {{value}} per sq ft',
        },
        sqft: {
          label: 'Area (sq ft)',
          placeholder: '280',
        },
        bedrooms: {
          label: 'Bedrooms',
        },
        bathrooms: {
          label: 'Bathrooms',
        },
        propertyType: {
          label: 'Property type',
        },
        yearBuilt: {
          label: 'Year built',
        },
        status: {
          label: 'Listing status',
        },
        featured: 'Highlight as featured listing',
        parking: 'Private parking available',
        petFriendly: 'Pet friendly',
        furnished: 'Fully furnished',
        description: {
          label: 'Description',
          placeholder: 'Share standout details, finishes, and nearby landmarks.',
        },
        address: {
          label: 'Street address',
        },
        city: {
          label: 'City',
        },
        state: {
          label: 'State / Region',
        },
        zipCode: {
          label: 'Postal code',
        },
        latitude: {
          label: 'Latitude (optional)',
          placeholder: '21.4858',
        },
        longitude: {
          label: 'Longitude (optional)',
          placeholder: '39.1925',
        },
        imageUrl: {
          label: 'Cover image URL',
          helper: 'Paste a hosted image link if you prefer.',
        },
        imageUpload: {
          label: 'Upload cover image',
        },
        galleryUrls: {
          label: 'Gallery URLs',
          placeholder: 'https://example.com/1.jpg\nhttps://example.com/2.jpg',
        },
        galleryUpload: {
          label: 'Upload gallery images',
        },
        utilities: {
          label: 'Included utilities',
          placeholder: 'Electricity\nWater\nHigh-speed internet',
        },
        amenities: {
          label: 'Amenities',
          placeholder: 'Infinity-edge pool\nSmart home controls\nPrivate cinema',
        },
        agentName: {
          label: 'Agent name',
        },
        agentPhone: {
          label: 'Agent phone',
          placeholder: 'e.g. +966 55 123 4567',
        },
        agentEmail: {
          label: 'Agent email',
        },
        reset: 'Reset form',
        submit: 'Publish listing',
        submitting: 'Publishing...',
      },
    },
    validation: {
      required: 'This field is required.',
      invalidPrice: 'Enter a valid price.',
      invalidArea: 'Enter a valid area.',
      invalidBedrooms: 'Bedrooms must be zero or greater.',
      invalidBathrooms: 'Bathrooms must be zero or greater.',
      invalidYear: 'Enter a year between 1900 and {{max}}.',
      invalidEmail: 'Enter a valid email address.',
      imageRequired: 'Add a cover image before publishing.',
      amenitiesRequired: 'List at least one amenity.',
      utilitiesRequired: 'List at least one utility.',
      invalidLatitude: 'Latitude must be between -90 and 90.',
      invalidLongitude: 'Longitude must be between -180 and 180.',
      imageUploadFailed: 'Image upload failed. Please try a different file.',
      galleryUploadFailed: 'Gallery upload failed. Please try again.',
      submissionError: 'Failed to publish your listing. Please try again.',
    },
  },
};

export default propertyCreate;
